import { Button, Form, Row, Col, Label } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { ArrowDownCircle, ArrowRightCircle } from 'react-feather';

import { toast } from 'react-hot-toast';
// import { ErrorToast } from '@/components/shared/CustomToast';
// import { useOptions } from '@/hooks/useOptions';
import FileUploaderSingle from './FileUploaderSingle';
import { useMutation, gql } from '@apollo/client';

export const UploadData = gql`
mutation ImportActivities($fileName: String!) {
  importActivities(fileName: $fileName)
}
`;

export const UploadDataEpisode = gql`
mutation ImportEpisodes($fileName: String!) {
  importEpisodes(fileName: $fileName)
}
`;

const UploadDataCenterMasiveForm = ({
  refetch,
  type,
  toggleSidebar,
  defaultValues
}) => {
  // const { loading: _loading, options } = useOptions();
  const {
    setValue,
    watch,
    handleSubmit
  } = useForm({
    defaultValues
  });

  const [handle, { loading }] = useMutation(type === 'episodios' ? UploadDataEpisode : UploadData);

  const onSubmit = async (data) => {
    toast
      .promise(
        handle({
          variables: {
              fileName: data.url
          },
          onError(error) {
            throw error.graphQLErrors;
          }
        }),
        {
          loading: 'Subiendo...',
          success: <b>Subido con exito!</b>,
          error: <b>No se pudo subir el archivo.</b>
        }
      )
      .then(({ errors }) => {
        if (!errors) {
          refetch();
          toggleSidebar();
        }
      })
      .catch((er) => {
        if (er[0]) {
          er.forEach((error) => {
            const message = error.extensions.exception.response.es;
            console.log(message);
            
            // toast((t) => <ErrorToast t={t} message={message} />);
          });
        }
      });
  };

  const handleDownload = () => {
    const link = type === 'episodios' ? 'https://sublime-multimedia.s3.us-east-1.amazonaws.com/c1021135736dafcd403d2e81106cb8c39.xlsx' : 'https://sublime-multimedia.s3.us-east-1.amazonaws.com/c7f01b72edcf0d0635210d77e91b682ee.xlsx';
    const a = document.createElement('a');
    a.href = link;
    a.download = link;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col className="mb-3">
          <div className="mt-2 ml-3">
            <h1
              style={{
                font: 'normal normal 600 18px/27px Geist',
                color: '#636A6C',
                textAlign: 'left',
                marginBottom: 10
              }}
            >
              Cargar {type === 'episodios' ? 'Episodios' : 'Actividades '} Masivo
            </h1>
          </div>
          <div className="ml-3 mb-3">
            <span
              style={{
                font: 'normal normal normal 14px/21px Geist',
                color: '#636A6C'
              }}
            >
              Para subir una actividad, primero debes descargar la plantilla y luego subir el archivo de Excel. Sin embargo, ten en cuenta que si subes un nuevo archivo, los datos previamente cargados serán reemplazados
            </span>
          </div>
          <Button
            className="round d-flex align-items-center justify-content-between"
            color="primary"
            onClick={handleDownload}
          >
            <span
              style={{
                fontWeight: 'bold',
                fontSize: 14,
                textAlign: 'center',
                color: '#191C1D'
              }}
            >
              Descargar Template
            </span>
            <ArrowDownCircle
              size={24}
              style={{
                marginLeft: 5
              }}
            />
          </Button>
        </Col>
      </Row>

      <Row className="">
        <Col md="12">
          <label className="text-sidebar3 mb-1">Subir Archivo</label>
          <FileUploaderSingle
            etlFileName={type}
            setField={(url) => setValue('url', url)}
          />
        </Col>
        <Col md="6" />
        {watch('url') && (
          <Col md="6">
            <Button
              type="submit"
              className="round "
              color="primary"
              block
              style={{
                width: 150
              }}
              disabled={loading}
              size="sm"
            >
              <div className="d-flex align-items-center justify-content-between">
                <div />
                <span className="fw-bolder">Finalizar</span>
                <ArrowRightCircle size={20} />
              </div>
            </Button>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default UploadDataCenterMasiveForm;
